function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { getLatestAppVersion } from '@repo/utils';
import { createColumnHelper } from '@tanstack/react-table';
import { ModuleDependencyRenderer, ModuleOrApplicationLinkRenderer } from '../ModulesDependencies';
const columnHelper = createColumnHelper();
export const configureColumnDefs = (applications, organization, project)=>{
    if (applications.length === 0 || !organization || !project) {
        return [];
    }
    return [
        columnHelper.accessor((row)=>row, {
            id: 'moduleName',
            header: ()=>'Modules',
            cell: (inf)=>/*#__PURE__*/ _jsx(ModuleOrApplicationLinkRenderer, {
                    organization: organization,
                    project: project,
                    value: inf.getValue().name
                })
        }),
        ...applications.map((application)=>columnHelper.accessor((row)=>row, {
                id: application.id,
                header: ()=>/*#__PURE__*/ _jsx(ModuleOrApplicationLinkRenderer, {
                        organization: organization,
                        type: "application",
                        project: project,
                        application: application.name,
                        value: application.name
                    }),
                cell: (inf)=>/*#__PURE__*/ _jsx(ModuleDependencyRenderer, {
                        value: inf.getValue()[application.id]
                    })
            }))
    ];
};
export const convertToRowData = (applications)=>{
    const overridesComplete = applications.reduce((oc, param)=>{
        let { id, versions } = param;
        var _getLatestAppVersion_overrides, _getLatestAppVersion;
        (_getLatestAppVersion = getLatestAppVersion(versions !== null && versions !== void 0 ? versions : [])) === null || _getLatestAppVersion === void 0 ? void 0 : (_getLatestAppVersion_overrides = _getLatestAppVersion.overrides) === null || _getLatestAppVersion_overrides === void 0 ? void 0 : _getLatestAppVersion_overrides.forEach((param)=>{
            let { name } = param;
            var _oc, _name, _;
            (_ = (_oc = oc)[_name = name]) !== null && _ !== void 0 ? _ : _oc[_name] = [];
            oc[name].push(id);
        });
        return oc;
    }, {});
    const getOverridesApplicationsRelationship = (applications, overridesApplicationsIds)=>{
        return applications.reduce((memo, param)=>{
            let { id } = param;
            if (overridesApplicationsIds.includes(id)) {
                memo[id] = {
                    type: 'up'
                };
            }
            return memo;
        }, {});
    };
    return Object.entries(overridesComplete).map((param)=>{
        let [name, overridesApplicationsIds = []] = param;
        return _object_spread({
            name
        }, getOverridesApplicationsRelationship(applications, overridesApplicationsIds));
    });
};
